import React from "react"

import ComponentWithData from "~/utils/ComponentWithData"
import {Destination} from "~/utils/ShelfEntities"

import {TitleSection, SearchableList, ListItemDestination} from "~/components/"
import {withTranslation} from "react-i18next"

class DestinationsView extends ComponentWithData {
  getData() {
    Destination.all()
      .then(destinations => {
        this.setState({data: destinations, resource_loader_state: "successful"})
      })
      .catch(err => {
        console.log("Error loading destinations data: " + err)
      })
  }

  componentDidMount() {
    this.getData()
  }

  update() {
    this.getData()
  }

  getFilteredItems(query) {
    let lowerCaseQuery = query.toLowerCase()
    return this.state.data.filter(destination =>
      destination.name.toLowerCase().includes(lowerCaseQuery)
    )
  }

  renderLoading = () => <p>{this.props.t("destinations.loading")}</p>
  renderError = () => <p>{this.props.t("destinations.error")}</p>

  renderWithData() {
    return (
      <React.Fragment>
        <TitleSection>
          <h3>{this.props.t("destinations.title")}</h3>
        </TitleSection>

        <SearchableList
          filteredItems={this.getFilteredItems.bind(this)}
          itemRenderer={ListItemDestination}
          update={this.update.bind(this)}
        >
          <p>{this.props.t("destinations.nothing")}</p>
        </SearchableList>
      </React.Fragment>
    )
  }
}

export default withTranslation()(DestinationsView)



// WEBPACK FOOTER //
// ./src/views/DestinationsView.js